import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import companyApi from '../../../api/company.api';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { Container } from './style';
import ImageUploadWithPreview from '../../../components/ImageUpload';
import { toast } from 'react-toastify';
import { ECompanyType, ICompany } from '../../../models/company.model';
import RegionSelect from '../../../components/RegionSelect';
import { MultipleImageUploader } from '../../../components/MultipleImageUploader';
import CompanyTypeSelect from '../../../components/CompanyTypeSelect';
import { useNavigate } from 'react-router-dom';
import VisibleSelect from '../../../components/VisibleSelect';

export default function PortfolioCreatePage() {
  const [data, setData] = useState<Partial<ICompany>>({
    type: ECompanyType.Building,
    hidden: false,
    order: 0,
  });
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  return (
    <Container>
      <Box
        sx={{
          width: '100%',
          p: 2,
          boxSizing: 'border-box',
        }}
      >
        <Grid container columnSpacing={2} rowSpacing={4}>
          <Grid item xs={12}>
            <Typography variant="h3" p={1}>
              Create company
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h5" p={1}>
              Logo
            </Typography>

            <ImageUploadWithPreview
              value={data?.logo_url}
              onChange={(value) => {
                if (data) {
                  setData({
                    ...data,
                    logo_url: value,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h5" p={1}>
              Secondary Logo
            </Typography>

            <ImageUploadWithPreview
              value={data?.secondary_logo}
              onChange={(value) => {
                if (data) {
                  setData({
                    ...data,
                    secondary_logo: value,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <Typography variant="h5" p={1}>
              Backdrop Image
            </Typography>

            <ImageUploadWithPreview
              value={data?.backdrop_image}
              onChange={(value) => {
                if (data) {
                  setData({
                    ...data,
                    backdrop_image: value,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Name
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vietnamese"
              variant="outlined"
              size="small"
              value={data?.name_vi || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    name_vi: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="English"
              variant="outlined"
              size="small"
              value={data?.name_en || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    name_en: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Detail
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <TextField
              label="Order"
              variant="outlined"
              size="small"
              value={data?.order || 0}
              type="number"
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    order: +ev.currentTarget.value || 0,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <CompanyTypeSelect
              value={data?.type ?? ECompanyType.Building}
              onChange={(item) => {
                if (data) {
                  setData({
                    ...data,
                    type: item,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <RegionSelect
              value={data?.country?.id}
              onChange={(item) => {
                if (data) {
                  setData({
                    ...data,
                    country: item,
                    country_id: item?.id ?? null,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} lg={3}>
            <VisibleSelect
              value={!data?.hidden}
              onChange={(item) => {
                if (data) {
                  setData({
                    ...data,
                    hidden: !item,
                  });
                }
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Founder
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vietnamese"
              variant="outlined"
              size="small"
              value={data?.founder_vi || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    founder_vi: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="English"
              variant="outlined"
              size="small"
              value={data?.founder_en || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    founder_en: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>

          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Description
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vietnamese"
              variant="outlined"
              size="small"
              multiline
              rows={4}
              value={data?.description_vi || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    description_vi: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="English"
              variant="outlined"
              size="small"
              multiline
              rows={4}
              value={data?.description_en || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    description_en: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Website
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Vietnamese"
              variant="outlined"
              size="small"
              value={data?.website_vi || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    website_vi: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="English"
              variant="outlined"
              size="small"
              value={data?.website_en || ''}
              onChange={(ev) => {
                if (data) {
                  setData({
                    ...data,
                    website_en: ev.currentTarget.value,
                  });
                }
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" p={1}>
              Content Images
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <MultipleImageUploader
              values={data?.content_images}
              onChange={(values) => {
                if (data) {
                  setData({
                    ...data,
                    content_images: values,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              disabled={loading || !data}
              sx={{ minWidth: 200 }}
              variant="contained"
              onClick={() => {
                if (data) {
                  setLoading(true);
                  companyApi
                    .create({
                      ...data,
                    })
                    .then((res) => {
                      toast.success('Create successful');
                      navigate('/portfolio/detail/' + res.data.id);
                    })
                    .catch((err) => {
                      toast.error(err.response.data.message);
                    })
                    .finally(() => {
                      setLoading(false);
                    });
                }
              }}
            >
              Save
            </Button>
          </Grid>
        </Grid>
        <div style={{ height: 100 }} />
      </Box>
    </Container>
  );
}
